/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import TimelineEvent from 'solis/logic/board/zone/timeline/event';


export default class InitialEvent extends TimelineEvent
{
  constructor (zone)
  {
    super(zone);
  }


  findNextDate (startDate)
  {
    this.date = startDate;
  }


};
